export const PROD = {
    ENV: 'PROD',
    BASE_URL: 'https://funds.morningstar.cn',
    EXPORT_API: 'https://chinabusinessapi.morningstar.cn',
};

export const UAT = {
    ENV: 'UAT',
    BASE_URL: 'https://funds-uat.morningstar.cn',
    EXPORT_API: 'https://chinabusinessapi.morningstar.cn',
};

export const getENV = () => {
    const host = window.location.host;
    if (host.includes('-qa') || host.includes('localhost')) {
        return UAT;
    }
    return PROD;
};